import { render, staticRenderFns } from "./WebsiteAppointment.vue?vue&type=template&id=28ae22e0&scoped=true&"
import script from "./WebsiteAppointment.vue?vue&type=script&lang=js&"
export * from "./WebsiteAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae22e0",
  null
  
)

export default component.exports